import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importOverpaymentResolvedSuccess = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "OverpaymentResolvedSuccess" */
                '@perpay-web/fintech/components/screens/OverpaymentResolvedSuccess/OverpaymentResolvedSuccess'
            ),
    );
